import $ from 'jquery'
import _ from 'lodash'
import { createAlert } from 'dom/window'
// import { fetchJSONData } from '_utils';
// import { toggleLoading } from '../actions/defaultActions';
import {
  convertProductsListingToAReadableFormat,
  convertHasCocktailsToAReadableFormat,
  convertProductListingCategories,
  convertOrderTemplateListingCategories,
} from '../selectors/productSelectors'
import { buildRequestProductListParams } from '../../main/selectors/defaultSelectors'
import {
  axiosRequestProcessedProductsPrices,
  axiosRequestProductHasCocktails,
  updateProductsListUnsort,
  requestProductsPrices,
  requestProductsByIDs,
  updateProductsList,
  toggleProductsLoading,
  requestDealsProductsByIDs,
  requestProductsTemplate,
  updateProductCocktails,
  requestProductCocktails,
  updateCategoriesOrderTemplate,
} from '../actions/productsActions'
import { convertProductsPricesToAReadableFormat } from '../selectors/productSelectors'
import { getProductsArray, getProductsFullInfo } from '../selectors/defaultSelectors'

import { axiosInstance as axios, handleAxiosErrors, breakListIntoChunks, createAxiosCancellationToken } from '_utils'
import config from 'store/_config'
import { segmentTrackProductAddedToWishlist, segmentTrackProductRemovedFromWishlist } from '../utils/segment/ecommerce'
import { isInDeal, requestProductDeals, toggleDealBuilderListAvailable } from './promoDealsActions'
import { updateCocktails } from './cocktailsActions'

let cancelToken = {}

export const toggleOrderTemplateLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_ORDER_TEMPLATE_LOADING',
      value: value,
    })
  }
}
export const toggleDealBuilderLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_DEAL_BUILDER_LOADING',
      value: value,
    })
  }
}

export const removeTemplateLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'REMOVE_TEMPLATE_LOADING',
      value: value,
    })
  }
}

export const removeNotifyLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'REMOVE_NOTIFY_LOADING',
      value: value,
    })
  }
}

export const toggleFullRangeLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_FULL_RANGE_LOADING',
      value: value,
    })
  }
}

export const toggleDiscountPriceLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_DISCOUNT_PRICE_LOADING',
      value: value,
    })
  }
}

export const togglePriceLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_DISCOUNT_SYNC',
      value: value,
    })
  }
}

export const requestFullRange = (data) => {
  return (dispatch, getState) => {
    const state = getState()
    const { user, base_group, key } = state.user
    const searchKeyword = data.search || ''
    const categoryFilters = state.user.categoryFilters
    const valuesArray = []

    const newList = Object.values(categoryFilters).reduce((values, item) => {
      // if (values.length > 0) return values; // TODO: remove this
      if (item.checked) {
        let pushedValue = item.id
        valuesArray.push(pushedValue)
      }
      return valuesArray
    }, [])

    console.log('updated list')
    console.log(newList.toString().split(/\|/))
    const pipList = newList.join('|')
    console.log(pipList)
    let { url, query } = config.orderTemplate.fullRange

    query = query.replace(
      /{params}/,
      buildRequestProductListParams({
        q: searchKeyword,
        limit: 20,
        offset: 0,
        DisplayPrice__gte: 0,
        DisplayPrice__lte: 10000,
        Filters: pipList,
      })
    )

    dispatch(toggleFullRangeLoading(true))
    dispatch(togglePriceLoading(true))
    if (cancelToken.searchResult) {
      cancelToken.searchResult.cancel()
    }

    cancelToken.searchResult = createAxiosCancellationToken()

    return axios
      .get(url, {
        withCredentials: true,
        params: {
          query: query,
        },
        cancelToken: cancelToken.searchResult.token,
      })
      .then((response) => {
        const searchResultProducts = convertProductsListingToAReadableFormat(
          response.data.data.searchResult.edges,
          state.user
        )

        // Get product IDs to request price
        const productIDs = searchResultProducts.map((item) => item.productID)

        // CustomerPromo
        axiosRequestProcessedProductsPrices(productIDs).then((response) => {
          const productsPrices = convertProductsPricesToAReadableFormat(response.data.data.readProductPrices, false)

          const products = _.merge(_.keyBy(searchResultProducts, 'id'), _.keyBy(productsPrices, 'id'))

          // wait for async requests
          Promise.all([dispatch(setFullRange(products)), dispatch(updateProductsListUnsort(products))]).then(() => {
            dispatch(requestProductsPrices(productIDs, searchResultProducts))
            dispatch(requestProductHasCocktails(productIDs))
            // dispatch(togglePriceLoading(false))
          })
        })
      })
      .catch((error) => {
        return handleAxiosErrors(error)
      })
  }
}
export const requestProductHasCocktails = (list) => {
  return (dispatch, getState) => {
    // TODO: Let's try to deprecate below
    return ''

    const state = getState()

    if (list && list.length > 0) {
      return axiosRequestProductHasCocktails(state, list)
        .then((response) => {
          const data = response.data.data.readProducts.edges

          const products = convertHasCocktailsToAReadableFormat(data, state.orderTemplate.fullRange)
          dispatch(updateFullRange(products))
        })
        .catch((error) => handleAxiosErrors(error))
    }
  }
}
export const setFullRange = (list) => {
  return {
    type: 'SET_FULL_RANGE',
    list,
  }
}
export const updateFullRange = (list) => {
  return {
    type: 'UPDATE_FULL_RANGE',
    list: _.keyBy(list, 'id'),
  }
}

export const setProductIsAddToTemplateStatus = (ID, status) => {
  return (dispatch, getState) => {
    const state = getState()
    const productList = state.products.list
    const cocktailList = state.cocktails.list

    //  const dealsList = state.dealBuilder.list
    if (typeof productList[ID] != 'undefined') {
      const updatedList = {
        [ID]: {
          id: ID,
          isAddToTemplate: status,
        },
      }

      dispatch(updateProductsList(updatedList))
    }
  }
}

export const addToTemplate = (product) => {
  return (dispatch, getState) => {
    let { url, query } = config.orderTemplate.add
    dispatch(removeTemplateLoading(true))
    const { caseQty = 0, case_price, unitQty = 0, unit_price, sell_by_case, isAddToTemplate } = product

    if (case_price) {
      segmentTrackProductAddedToWishlist(product, {
        price: case_price,
        variant: 'case',
        quantity: caseQty,
      })
    }

    if (!sell_by_case && unit_price > 0) {
      segmentTrackProductAddedToWishlist(product, {
        price: unit_price,
        variant: 'unit',
        quantity: unitQty,
      })
    }

    return axios
      .post(url, {
        query: query,
        variables: {
          BuyableID: product.id,
        },
      })
      .then((response) => {
        if (response.data.data.createWishListItem) {
          createAlert({ message: 'Item successfully added to template.' }, 'success')
          dispatch(setProductIsAddToTemplateStatus(product.id, true))
          dispatch(requestProductDeals())
          dispatch(removeTemplateLoading(false))
          return true
        }
        createAlert({}, 'error')
        return false
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const removeProductOrderTemplate = (product) => {
  return (dispatch, getState) => {
    let { url, query } = config.orderTemplate.removeProductFromOrderTemplate

    return axios
      .post(url, {
        query: query,
        variables: {
          BuyableID: product.id,
        },
      })
      .then((response) => {
        if (response.data.data.deleteWishListItemByBuyable !== undefined) {
          dispatch(setProductIsAddToTemplateStatus(product.id, false))
          dispatch(requestProductDeals())
          createAlert(
            {
              message: `Item successfully removed from template.`,
            },
            'success'
          )
          return
        }

        createAlert({}, 'error')
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const removeOrderTemplate = (list) => {
  return (dispatch, getState) => {
    let { url, query } = config.orderTemplate.remove
    const state = getState()

    const orderTemplateList = state.orderTemplate.list
    const orderTemplateFullInfo = getProductsFullInfo(orderTemplateList, state)

    list.map((item) => {
      const id = parseInt(item.id, 10)
      if (orderTemplateFullInfo[id]) {
        const orderTemplateProduct = orderTemplateFullInfo[id]
        const { caseQty = 0, case_price, unitQty = 0, unit_price, sell_by_case } = orderTemplateProduct

        if (case_price) {
          segmentTrackProductRemovedFromWishlist(orderTemplateProduct, {
            price: case_price,
            variant: 'case',
            quantity: caseQty,
          })
        }

        if (!sell_by_case && unit_price > 0) {
          segmentTrackProductRemovedFromWishlist(orderTemplateProduct, {
            price: unit_price,
            variant: 'unit',
            quantity: unitQty,
          })
        }
      }
    })

    query = query.replace(
      /{params}/,
      buildRequestProductListParams({
        BuyableIDs: list.reduce((items, item) => {
          items.push(parseInt(item.id, 10))
          return items
        }, []),
      })
    )

    return axios
      .get(url, {
        withCredentials: true,
        params: {
          query: query,
        },
      })
      .then((response) => {
        const $modal = $('#confirm-removal-modal')

        $modal.modal('hide')

        if (response.data.data.deleteWishListItemByBuyable !== undefined) {
          dispatch({
            type: 'REMOVE_ORDER_TEMPLATE',
            list: _.keyBy(list, 'id'),
          })

          createAlert(
            {
              message: `${list.length} product(s) have been removed from order template`,
            },
            'success'
          )
          return
        }

        createAlert({}, 'error')
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const requestOrderTemplate = (params) => {
  return (dispatch, getState) => {
    let { url, query } = config.orderTemplate.listing
    const state = getState()
    dispatch(toggleOrderTemplateLoading(true))
    dispatch(togglePriceLoading(true))
    console.log(state.products.discountPrice)
    return axios
      .get(url, {
        withCredentials: true,
        params: {
          query,
        },
      })
      .then((response) => {
        const products = convertOrderTemplateToAReadableFormat(response.data.data.readOrderTemplate.edges)
        const productsIDS = products.reduce((items, product) => {
          items.push(product.id)
          return items
        }, [])

        if (!products.length) {
          dispatch(toggleOrderTemplateLoading(false))
          return
        }
        /**
         * Break the request into every 100
         */
        let promisedRequests = []

        const chunkedList = breakListIntoChunks(productsIDS, 100)

        chunkedList.map((chunkedProductIDs) => {
          promisedRequests.push(
            dispatch(
              requestProductsByIDs({ products: chunkedProductIDs }, (products) => {
                /**
                 * Got some redundant product ID from readOrderTemplate
                 * Need to update product in the order template after readProducts
                 */

                const responseProducts = products.map((x) => {
                  return {
                    id: parseInt(x.id, 10),
                    // isDeal : isInDeal(x.sku, state)
                  }
                })
                const categoriesHolder = Object.values(products)
                const categories = convertOrderTemplateListingCategories(categoriesHolder, state.user)
                dispatch(updateCategoriesOrderTemplate(categories))
                dispatch(updateOrderTemplate(responseProducts))
              })
            )
          )
        })

        Promise.all(promisedRequests).then(async () => {
          await dispatch(toggleOrderTemplateLoading(false))
          await dispatch(OrderTemplateFilter())
        })
        dispatch(OrderTemplateFilter())
        // dispatch(toggleDiscountPriceLoading(false))
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const OrderTemplateFilter = () => {
  return (dispatch, getState) => {
    const state = getState()
    let orderTemplateList = state.orderTemplate.list
    const orderTemplateFullInfo = getProductsFullInfo(orderTemplateList, state)
    const orderTemplate = getProductsArray(orderTemplateFullInfo)
    if (orderTemplate.some((item) => item.isDeal === true)) {
      dispatch(toggleDealBuilderListAvailable(true))
    }
  }
}

export const toggleFilter = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    // const { key, index } = params; // TODO: remove this
    const { key, id } = params
    let filters = state.user.categoryFilters
    dispatch({
      type: 'TOGGLE_GLOBAL_CONFIG_FILTERS',
      value: {
        ...filters,
        [id]: {
          ...filters[id],
          checked: !filters[id].checked,
          // TODO: remove this
          // [index]: {
          //     ...filters[key][index],
          //     checked: !filters[key][index].checked
          // }
        },
      },
    })
    dispatch(reloadFilters())
  }
}

export const reloadFilters = () => {
  return (dispatch, getState) => {
    const state = getState()
    const filters = state.user.categoryFilters

    // dispatch(setActivePage(1))
    if (checkIfThereAreFiltersActive(filters)) {
      dispatch(toggleActiveFilters(true))
    } else {
      dispatch(toggleActiveFilters(false))
    }

    // dispatch(requestFilteredPromoDealsOrderTemplate())
  }
}

export const clearFiltersOrderTemplate = () => {
  return (dispatch, getState) => {
    const state = getState()
    const filters = state.user.categoryFilters
    Object.values(filters).map((item, idnex) => {
      item.checked = false
    })

    dispatch({
      type: 'TOGGLE_GLOBAL_CONFIG_FILTERS',
      value: {
        ...filters,
      },
    })
    dispatch(reloadFilters())
  }
}

export const checkIfThereAreFiltersActive = (filters) => {
  let checked = false

  Object.values(filters).map((item, index) => {
    if (item.checked) checked = true
  })

  return checked
}

export const toggleActiveFilters = (flag) => {
  return {
    type: 'TOGGLE_ACTIVE_GLOBAL_CONFIG_FILTERS',
    value: flag,
  }
}

export const requestFilteredPromoDealsOrderTemplate = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const categoryFilters = state.user.categoryFilters
    const valuesArray = []

    const searchKeyword = params?.category || ''
    const newList = Object.values(categoryFilters).reduce((values, item) => {
      // if (values.length > 0) return values; // TODO: remove this
      if (item.checked) {
        let pushedValue = item.id
        valuesArray.push(pushedValue)
      }
      return valuesArray
    }, [])

    console.log('updated list')
    console.log(newList.toString().split(/\|/))
    const pipList = newList.join('|')
    console.log(pipList)
    let { url, query } = config.orderTemplate.filter

    // const searchKeyword = params.promoCategory || ''
    query = query.replace(
      /{params}/,
      buildRequestProductListParams({
        Filters: pipList,
        Title: searchKeyword,
      })
    )

    dispatch(toggleOrderTemplateLoading(true))

    return axios
      .get(url, {
        withCredentials: true,
        params: {
          query,
        },
      })
      .then((response) => {
        const products = convertOrderTemplateToAReadableFormat(response.data.data.readOrderTemplate.edges)
        const productsIDS = products.reduce((items, product) => {
          items.push(product.id)
          return items
        }, [])

        if (!products.length) {
          const emptyProducts = []
          dispatch(filterOrderTemplate(emptyProducts))
          dispatch(toggleOrderTemplateLoading(false))
          dispatch(setNullFilteredOrderTemplate(true))
          return
        }

        /**
         * Break the request into every 100
         */
        let promisedRequests = []
        const chunkedList = breakListIntoChunks(productsIDS, 100)

        chunkedList.map((chunkedProductIDs) => {
          promisedRequests.push(
            dispatch(
              requestProductsByIDs({ products: chunkedProductIDs }, (products) => {
                /**
                 * Got some redundant product ID from readOrderTemplate
                 * Need to update product in the order template after readProducts
                 */
                const responseProducts = products.map((x) => {
                  return {
                    id: parseInt(x.id, 10),
                  }
                })

                dispatch(filterOrderTemplate(responseProducts))
                dispatch(setNullFilteredOrderTemplate(false))
              })
            )
          )
        })

        Promise.all(promisedRequests).then(() => {
          dispatch(toggleOrderTemplateLoading(false))
        })
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const requestFilteredOrderTemplate = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const categoryFilters = state.user.categoryFilters
    const valuesArray = []

    const newList = Object.values(categoryFilters).reduce((values, item) => {
      // if (values.length > 0) return values; // TODO: remove this
      if (item.checked) {
        let pushedValue = item.id
        valuesArray.push(pushedValue)
      }
      return valuesArray
    }, [])

    console.log('updated list')
    console.log(newList.toString().split(/\|/))
    const pipList = newList.join('|')
    console.log(pipList)

    let { url, query } = config.orderTemplate.filter
    const searchKeyword = params.category || ''
    query = query.replace(
      /{params}/,
      buildRequestProductListParams({
        Title: searchKeyword,
        Filters: pipList,
      })
    )

    dispatch(toggleOrderTemplateLoading(true))

    return axios
      .get(url, {
        withCredentials: true,
        params: {
          query,
        },
      })
      .then((response) => {
        const products = convertOrderTemplateToAReadableFormat(response.data.data.readOrderTemplate.edges)
        const productsIDS = products.reduce((items, product) => {
          items.push(product.id)
          return items
        }, [])

        if (!products.length) {
          const emptyProducts = []
          dispatch(filterOrderTemplate(emptyProducts))
          dispatch(toggleOrderTemplateLoading(false))
          dispatch(setNullFilteredOrderTemplate(true))
          return
        }

        /**
         * Break the request into every 100
         */
        let promisedRequests = []
        const chunkedList = breakListIntoChunks(productsIDS, 100)

        chunkedList.map((chunkedProductIDs) => {
          promisedRequests.push(
            dispatch(
              requestProductsByIDs({ products: chunkedProductIDs }, (products) => {
                /**
                 * Got some redundant product ID from readOrderTemplate
                 * Need to update product in the order template after readProducts
                 */
                const responseProducts = products.map((x) => {
                  return {
                    id: parseInt(x.id, 10),
                  }
                })

                dispatch(filterOrderTemplate(responseProducts))
                dispatch(setNullFilteredOrderTemplate(false))
              })
            )
          )
        })

        Promise.all(promisedRequests).then(() => {
          dispatch(toggleOrderTemplateLoading(false))
        })
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const convertOrderTemplateToAReadableFormat = (list) => {
  let newList = []

  list.map((item) => {
    const BuyableID = item?.node?.BuyableID
    newList.push({
      id: BuyableID,
    })
  })

  return newList
}
export const toggleOrderTemplate = (flag) => {
  return (dispatch, getState) => {
    if (flag) {
      $('#order-template-list').show()
      $('#order-template-empty').hide()
    } else {
      $('#order-template-list').hide()
      $('#order-template-empty').show()
    }
  }
}
export const updateOrderTemplate = (list) => {
  return {
    type: 'UPDATE_ORDER_TEMPLATE',
    list: _.keyBy(list, 'id'),
  }
}
export const updateDealBuilder = (list) => {
  return {
    type: 'UPDATE_DEAL_BUILDER',
    // list: _.keyBy(list, 'id'),
    list: list,
  }
}
export const setDealBuilder = (list) => {
  return {
    type: 'SET_DEAL_BUILDER',
    list: list,
  }
}
export const filterOrderTemplate = (list) => {
  return {
    type: 'FILTER_ORDER_TEMPLATE',
    list: _.keyBy(list, 'id'),
  }
}
export const setNullFilteredOrderTemplate = (value) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_NULL_FILTERED_ORDER_TEMPLATE',
      value: value,
    })
  }
}
